/**
 * The `plan_id` to persist from the admin partner dialog.
 *
 * A plan can only be changed while the partner grant is enabled — assigning a
 * plan to a non-partner user is pointless because the billing system would
 * downgrade it back to Free. So we only send the plan change when `isPartner`
 * is set (and a plan is actually selected).
 *
 * @returns the plan id to send, or `undefined` to leave the plan untouched.
 */
export function resolvePartnerPlanId(
  { isPartner, planId }: { isPartner: boolean; planId: string },
): string | undefined {
  return isPartner && planId ? planId : undefined;
}
